import {
  CloudDisabledIcon,
  CloudErrorIcon,
  CloudNewIcon,
  CloudSuccessIcon,
  CloudUnknownIcon,
  CloudWarningIcon,
  EDRDisabledIcon,
  EDRErrorIcon,
  EDRNewIcon,
  EDRSuccessIcon,
  EDRUnknownIcon,
  EDRWarningIcon,
  LogFwdDisabledIcon,
  LogFwdErrorIcon,
  LogFwdNewIcon,
  LogFwdSuccessIcon,
  LogFwdUnknownIcon,
  LogFwdWarningIcon,
  SensorDisabledIcon,
  SensorErrorIcon,
  SensorNewIcon,
  SensorSuccessIcon,
  SensorUnknownIcon,
  SensorWarningIcon,
  SourceDisabledIcon,
  SourceErrorIcon,
  SourceNewIcon,
  SourceSuccessIcon,
  SourceUnknownIcon,
  SourceWarningIcon,
  VMPDisabledIcon,
  VMPErrorIcon,
  VMPNewIcon,
  VMPSuccessIcon,
  VMPUnknownIcon,
  VMPWarningIcon
} from './DeviceCustomIcons';

export const DEVICE_STATUS_ICON_LIST = [
  {
    devicetype: 'Cloud Collector',
    icon: CloudSuccessIcon,
    status: 'Active'
  },
  {
    devicetype: 'Cloud Collector',
    icon: CloudWarningIcon,
    status: 'Warning'
  },
  {
    devicetype: 'Cloud Collector',
    icon: CloudUnknownIcon,
    status: 'Unknown'
  },
  {
    devicetype: 'Cloud Collector',
    icon: CloudErrorIcon,
    status: 'Error'
  },
  {
    devicetype: 'Cloud Collector',
    icon: CloudDisabledIcon,
    status: 'Disabled'
  },
  {
    devicetype: 'Cloud Collector',
    icon: CloudNewIcon,
    status: 'New'
  },
  {
    devicetype: 'Cloud Collector',
    icon: CloudNewIcon,
    status: ''
  },
  {
    devicetype: 'Cloud Collector',
    icon: CloudWarningIcon,
    status: 'Decommissioning'
  },
  {
    devicetype: 'Log Forwarder',
    icon: LogFwdSuccessIcon,
    status: 'Active'
  },
  {
    devicetype: 'Log Forwarder',
    icon: LogFwdWarningIcon,
    status: 'Warning'
  },
  {
    devicetype: 'Log Forwarder',
    icon: LogFwdWarningIcon,
    status: 'Decommissioning'
  },
  {
    devicetype: 'Log Forwarder',
    icon: LogFwdUnknownIcon,
    status: 'Unknown'
  },
  {
    devicetype: 'Log Forwarder',
    icon: LogFwdErrorIcon,
    status: 'Error'
  },
  {
    devicetype: 'Log Forwarder',
    icon: LogFwdDisabledIcon,
    status: 'Disabled'
  },
  {
    devicetype: 'Log Forwarder',
    icon: LogFwdNewIcon,
    status: 'New'
  },
  {
    devicetype: 'Log Forwarder',
    icon: LogFwdNewIcon,
    status: ''
  },
  {
    devicetype: 'Sensor',
    icon: SensorSuccessIcon,
    status: 'Active'
  },
  {
    devicetype: 'Sensor',
    icon: SensorWarningIcon,
    status: 'Warning'
  },
  {
    devicetype: 'Sensor',
    icon: SensorWarningIcon,
    status: 'Decommissioning'
  },
  {
    devicetype: 'Sensor',
    icon: SensorUnknownIcon,
    status: 'Unknown'
  },
  {
    devicetype: 'Sensor',
    icon: SensorErrorIcon,
    status: 'Error'
  },
  {
    devicetype: 'Sensor',
    icon: SensorDisabledIcon,
    status: 'Disabled'
  },
  {
    devicetype: 'Sensor',
    icon: SensorNewIcon,
    status: 'New'
  },
  {
    devicetype: 'Sensor',
    icon: SensorNewIcon,
    status: ''
  },
  {
    devicetype: 'EDR',
    icon: EDRSuccessIcon,
    status: 'Active'
  },
  {
    devicetype: 'EDR',
    icon: EDRWarningIcon,
    status: 'Warning'
  },
  {
    devicetype: 'EDR',
    icon: EDRWarningIcon,
    status: 'Decommissioning'
  },
  {
    devicetype: 'EDR',
    icon: EDRUnknownIcon,
    status: 'Unknown'
  },
  {
    devicetype: 'EDR',
    icon: EDRErrorIcon,
    status: 'Error'
  },
  {
    devicetype: 'EDR',
    icon: EDRDisabledIcon,
    status: 'Disabled'
  },
  {
    devicetype: 'EDR',
    icon: EDRNewIcon,
    status: 'New'
  },
  {
    devicetype: 'EDR',
    icon: EDRNewIcon,
    status: ''
  },
  {
    devicetype: 'VMP',
    icon: VMPSuccessIcon,
    status: 'Active'
  },
  {
    devicetype: 'VMP',
    icon: VMPWarningIcon,
    status: 'Warning'
  },
  {
    devicetype: 'VMP',
    icon: VMPWarningIcon,
    status: 'Decommissioning'
  },
  {
    devicetype: 'VMP',
    icon: VMPUnknownIcon,
    status: 'Unknown'
  },
  {
    devicetype: 'VMP',
    icon: VMPErrorIcon,
    status: 'Error'
  },
  {
    devicetype: 'VMP',
    icon: VMPDisabledIcon,
    status: 'Disabled'
  },
  {
    devicetype: 'VMP',
    icon: VMPNewIcon,
    status: 'New'
  },
  {
    devicetype: 'VMP',
    icon: VMPNewIcon,
    status: ''
  },
  {
    devicetype: 'VMPE',
    icon: VMPSuccessIcon,
    status: 'Active'
  },
  {
    devicetype: 'VMPE',
    icon: VMPWarningIcon,
    status: 'Warning'
  },
  {
    devicetype: 'VMPE',
    icon: VMPWarningIcon,
    status: 'Decommissioning'
  },
  {
    devicetype: 'VMPE',
    icon: VMPUnknownIcon,
    status: 'Unknown'
  },
  {
    devicetype: 'VMPE',
    icon: VMPErrorIcon,
    status: 'Error'
  },
  {
    devicetype: 'VMPE',
    icon: VMPDisabledIcon,
    status: 'Disabled'
  },
  {
    devicetype: 'VMPE',
    icon: VMPNewIcon,
    status: 'New'
  },
  {
    devicetype: 'VMPE',
    icon: VMPNewIcon,
    status: ''
  },
  {
    devicetype: 'source',
    icon: SourceSuccessIcon,
    status: 'Active'
  },
  {
    devicetype: 'source',
    icon: SourceWarningIcon,
    status: 'Warning'
  },
  {
    devicetype: 'source',
    icon: SourceUnknownIcon,
    status: 'Unknown'
  },
  {
    devicetype: 'source',
    icon: SourceErrorIcon,
    status: 'Error'
  },
  {
    devicetype: 'source',
    icon: SourceDisabledIcon,
    status: 'Disabled'
  },
  {
    devicetype: 'source',
    icon: SourceNewIcon,
    status: 'New'
  },
  {
    devicetype: 'source',
    icon: SourceNewIcon,
    status: ''
  }
];

export default DEVICE_STATUS_ICON_LIST;
